import Checkbox from '@mui/material/Checkbox';

import type { CheckboxState } from './utils/checkbox-list-state.util';

export const StateCheckbox = ({
  disabled,
  id,
  onChange,
  state,
}: Readonly<{
  disabled: boolean;
  id: string;
  onChange: () => void;
  state: CheckboxState;
}>) => (
  <Checkbox
    checked={state === 'checked'}
    disabled={disabled}
    id={id}
    indeterminate={state === 'indeterminate'}
    onChange={onChange}
  />
);
